/**
 * 指挥页实时绘制轨迹：本地持久化，避免页面刷新丢失
 */

export const REALTIME_TRACK_STORAGE_KEY = 'dashboard_realtime_tracks_v1';
const MAX_POINTS_PER_MEMBER = 2000;

/**
 * @returns {{ drawing: string[], trackData: Record<string, Array> }}
 */
export function loadPersistedRealtimeTracks(storage = typeof localStorage !== 'undefined' ? localStorage : null) {
  if (!storage) return { drawing: [], trackData: {} };
  try {
    const raw = storage.getItem(REALTIME_TRACK_STORAGE_KEY);
    if (!raw) return { drawing: [], trackData: {} };
    const parsed = JSON.parse(raw);
    const trackData = {};
    Object.entries(parsed.trackData || {}).forEach(([name, points]) => {
      if (!Array.isArray(points) || points.length === 0) return;
      trackData[name] = points
        .filter((p) => p && Number.isFinite(Number(p.lat)) && Number.isFinite(Number(p.lng)))
        .slice(-MAX_POINTS_PER_MEMBER);
    });
    const drawing = Array.isArray(parsed.drawing)
      ? parsed.drawing.filter((n) => typeof n === 'string' && trackData[n])
      : [];
    return { drawing, trackData };
  } catch (error) {
    console.warn('读取持久化实时轨迹失败:', error);
    return { drawing: [], trackData: {} };
  }
}

export function savePersistedRealtimeTracks(
  { drawing = [], trackData = {} } = {},
  storage = typeof localStorage !== 'undefined' ? localStorage : null
) {
  if (!storage) return false;
  try {
    const compactData = {};
    Object.entries(trackData || {}).forEach(([name, points]) => {
      if (!Array.isArray(points) || points.length === 0) return;
      compactData[name] = points.slice(-MAX_POINTS_PER_MEMBER).map((p) => ({
        lat: Number(p.lat),
        lng: Number(p.lng),
        timestamp: p.timestamp || null
      }));
    });
    const drawingNames = (Array.isArray(drawing) ? drawing : [...drawing])
      .filter((name) => compactData[name]);
    storage.setItem(
      REALTIME_TRACK_STORAGE_KEY,
      JSON.stringify({
        drawing: drawingNames,
        trackData: compactData,
        updatedAt: new Date().toISOString()
      })
    );
    return true;
  } catch (error) {
    console.warn('保存实时轨迹失败:', error);
    return false;
  }
}

export function clearPersistedRealtimeTracks(
  storage = typeof localStorage !== 'undefined' ? localStorage : null
) {
  try {
    storage?.removeItem?.(REALTIME_TRACK_STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
}

/** 清除单个队员的持久化绘制数据 */
export function removePersistedMemberRealtimeTrack(
  memberName,
  storage = typeof localStorage !== 'undefined' ? localStorage : null
) {
  const current = loadPersistedRealtimeTracks(storage);
  delete current.trackData[memberName];
  current.drawing = current.drawing.filter((n) => n !== memberName);
  savePersistedRealtimeTracks(current, storage);
}
